export default "__VITE_ASSET__BiD6bG6X__"